import { Injectable, signal } from '@angular/core';
import { ToastType } from '../../enums/toast.types';
import { Toast } from '../../models/toast.model';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts = signal<Toast[]>([]);

  show(message: string, type: ToastType, isProminent = false): void {
    const toast: Toast = { message, type, isProminent };
    this.toasts.update((currentToasts) => [...currentToasts, toast]);

    setTimeout(() => this.remove(toast), 3000);
  }

  remove(toast: Toast): void {
    this.toasts.update((currentToasts) => currentToasts.filter((t) => t !== toast));
  }
}
